import BogSettingsForm from './BogSettingsForm.jsx';
import { connect } from 'react-redux';
import { request as getBogSettings } from '../../../modules/system-settings/actions/get-bog-settings';
import { request as putBogSettings } from '../../../modules/system-settings/actions/put-bog-settings';

import { prepareDecimalFields } from './../../../utils/format';

import decorate from '../../../utils/decorate';

const FULL_TEXT_FIELDS = [
    'maxPayout'
];

function mapStateToProps(state) {
    let data = state.systemSettings.getIn([ 'bogSettings', 'data', 'configuration' ] );
    return {
        data: data ? prepareDecimalFields(data.toJS(), FULL_TEXT_FIELDS, '/') : false,
        status: state.systemSettings.getIn([ 'bogSettings', 'state' ] ) || 'IN_PROGRESS'
    };
}

function mapDispatchToProps(dispatch) {
    return {
        onBogSettingsGetRequest: () => dispatch(getBogSettings()),
        onBogSettingsPutRequest: ( data ) => {
            data = prepareDecimalFields( data, FULL_TEXT_FIELDS, '*')
            dispatch(putBogSettings( { data } ));
        }
    };
}

export default decorate(
    connect(mapStateToProps, mapDispatchToProps),
    BogSettingsForm
);
